import React from 'react';
import { Mail, Phone } from 'lucide-react';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="py-12 md:py-16" style={{ backgroundColor: '#111111' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-8 mb-12">

          <div className="space-y-4">
            <img
              src="https://customer-assets.emergentagent.com/job_5ecb04eb-657f-4ef6-b290-78fd64f7315c/artifacts/nnbtqpn5_logo.png"
              alt="NamoriSatya Legal"
              className="h-10 brightness-200"
            />
            <p className="text-sm font-semibold text-white">NAMORISATYA
LEGAL & ASSOCIATES</p>
            <p className="text-sm" style={{ color: '#999999' }}>Justice is not a favor. Its your right.</p>
          </div>

          <div>
            <h3 className="text-base font-bold text-white mb-4">Practice Areas</h3>
            <ul className="space-y-2">
              {['Civil Litigation', 'Criminal Law', 'Bail Matters', 'Property Disputes', 'Writ Petitions'].map((area) => (
                <li key={area}>
                  <button onClick={() => scrollToSection('practice-areas')} className="text-sm transition-colors hover:text-white" style={{ color: '#999999' }}>
                    {area}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-base font-bold text-white mb-4">Our Firm</h3>
            <ul className="space-y-2">
              {[{ label: 'About', id: 'about' }, { label: 'Our Team', id: 'team' }, { label: 'Contact Form', id: 'contact' }].map((item) => (
                <li key={item.label}>
                  <button onClick={() => scrollToSection(item.id)} className="text-sm transition-colors hover:text-white" style={{ color: '#999999' }}>
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-base font-bold text-white mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <Mail className="h-4 w-4 flex-shrink-0 mt-1" style={{ color: '#999999' }} />
                <span className="text-sm" style={{ color: '#999999' }}>officenamorisatyalegal@gmail.com</span>
              </li>
              <li className="flex items-start space-x-2">
                <Phone className="h-4 w-4 flex-shrink-0 mt-1" style={{ color: '#999999' }} />
                <div className="text-sm" style={{ color: '#999999' }}>
                  <div>+91 79039 27994</div>
                  <div>+91 74929 06530</div>
                </div>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-sm transition-colors hover:text-white" style={{ color: '#999999' }}>
                  Contact Form
                </button>
              </li>
            </ul>
          </div>

        </div>

        <div className="border-t pt-8" style={{ borderColor: '#333333' }}>
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm" style={{ color: '#999999' }}>2026 NamoriSatya Legal. All Rights Reserved.</p>
            <button className="text-sm transition-colors hover:text-white" style={{ color: '#999999' }}>Privacy Policy</button>
          </div>
          <p className="text-xs mt-4 text-center md:text-left" style={{ color: '#666666' }}>
            The Bar Council of India rules apply. This website is for informational purposes only.
          </p>
          <p className="text-xs mt-2 text-center md:text-left" style={{ color: '#666666' }}>
            Designed and Developed by{' '}
            <a href="https://jusgroww.in/" target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-white" style={{ color: '#2B2BFF' }}>
              Jusgroww
            </a>
          </p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;